import React, { useState, useEffect, useRef } from "react";
import {
  Checkbox,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  Card,
  CardContent,
  Grid,
  makeStyles,
} from "@material-ui/core";

import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const useStyles = makeStyles((theme) => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },

  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  card: {
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    padding: "20px",
    minHeight: "300px",
    borderRadius: "8px",
  },
  cardContent: {
    padding: "0px",
  },
}));

export default function ResourcesDialog({ name, members, staff, closeDialog }) {
  const classes = useStyles();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            maxWidth: "none",
          },
        }}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "800px",
              height: "100%",
              //minWidth: "600px",
              maxHeight: "650px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            paddingBottom: 0,
          }}
        >
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>

        <Box
          pt={1}
          pb={1}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Typography variant="h1" style={{ fontSize: 20 }}>
            {name} Resources
          </Typography>
        </Box>

        <DialogContent>
          <Grid
            container
            spacing={3}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              padding: "24px",
              paddingBottom:0,
              paddingTop: "4px",
            }}
          >
            <Grid item md={6}>
              <Card
                className={classes.card}
                style={{
                  maxWidth: "300px",
                  overflowY: "auto",
                }}
              >
                <Typography
                  variant="h4"
                  style={{
                    fontSize: 16,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Members
                </Typography>
                <Grid container alignItems="center">
                  <Grid item xs={6}>
                    <Typography variant="h4" style={{ paddingTop: 10 }}>
                      Name
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h4" style={{ paddingTop: 10 }}>
                      Role
                    </Typography>
                  </Grid>
                </Grid>
                {members.map((item) => (
                  <>
                    <Grid container alignItems="center">
                      <Grid item xs={6}>
                        <Typography variant="h5" style={{ paddingTop: 10 }}>
                          {item.name}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="h5" style={{ paddingTop: 10 }}>
                          {item.role}
                        </Typography>
                      </Grid>
                    </Grid>
                  </>
                ))}
              </Card>
            </Grid>
            <Grid item md={6}>
              <Card
                className={classes.card}
                style={{
                  maxWidth: "300px",
                  overflowY: "auto",
                }}
              >
                <Typography
                  variant="h4"
                  style={{
                    fontSize: 16,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Staff
                </Typography>
                <Grid container alignItems="center">
                  <Grid item xs={6}>
                    <Typography variant="h4" style={{ paddingTop: 10 }}>
                      Name
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h4" style={{ paddingTop: 10 }}>
                      Role
                    </Typography>
                  </Grid>
                </Grid>
                {staff.map((item) => (
                  <>
                    <Grid container alignItems="center">
                      <Grid item xs={6}>
                        <Typography variant="h5" style={{ paddingTop: 10 }}>
                          {item.name}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="h5" style={{ paddingTop: 10 }}>
                          {item.role}
                        </Typography>
                      </Grid>
                    </Grid>
                  </>
                ))}
              </Card>
            </Grid>
          </Grid>
          <Box pt={12} style={{display:"flex", justifyContent:"center"}}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 5 }}
              onClick={handleClose}
            >
              OK
            </Button>
          </Box>
        </DialogContent>

        <DialogActions style={{ justifyContent: "center"}}>

        </DialogActions>
      </Dialog>
    </div>
  );
}
